function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
var Deposit = require('./overlays/deposit');
var Withdraw = require('./overlays/withdraw');
var History = require('./overlays/history');
var Send = require('./overlays/send');
var Receive = require('./overlays/receive');
var Details = require('./overlays/details');

/*
	This is a container for all the independent overlays for sending (withdrawing), 
	depositing, sending, checking history of installed cryptocurrencies
*/
var SaitoCrypto = /*#__PURE__*/_createClass(function SaitoCrypto(app, mod) {
  _classCallCheck(this, SaitoCrypto);
  this.app = app;
  this.mod = mod;

  //'saito-crypto-deposit-render-request'
  this.deposit_overlay = new Deposit(app, mod);

  //'saito-crypto-withdraw-render-request'
  this.withdrawal_overlay = new Withdraw(app, mod);

  //'saito-crypto-history-render-request'
  this.history_overlay = new History(app, mod);

  //'saito-crypto-send-render-request'
  this.send_overlay = new Send(app, mod);

  //'saito-crypto-receive-render-request'
  this.receive_overlay = new Receive(app, mod);
  this.details_overlay = new Details(app, mod);
});
module.exports = SaitoCrypto;